import React, { useState } from "react";
import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { SendToClientButton } from "@/components/common/SendToClientButton";

const thisYear = new Date().getFullYear();
const YEARS = Array.from({ length: 6 }, (_, i) => String(thisYear - i));

export const AnnualReportButton = ({ clientSlug }) => {
  const [year, setYear] = useState(String(thisYear));
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get("/customer-satisfaction/annual-report.pdf", { params: { year, client_slug: clientSlug || undefined }, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `customer-satisfaction-report-${year}.pdf`; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Could not create the annual report"); } finally { setBusy(false); }
  };

  return (
    <div className="inline-flex items-center gap-1">
      <Select value={year} onValueChange={setYear}>
        <SelectTrigger className="h-9 w-[90px]" data-testid="cs-report-year-select"><SelectValue /></SelectTrigger>
        <SelectContent>{YEARS.map((y) => <SelectItem key={y} value={y}>{y}</SelectItem>)}</SelectContent>
      </Select>
      <Button variant="outline" size="sm" onClick={download} disabled={busy} data-testid="cs-annual-report-button">
        <FileText className="h-4 w-4 mr-1" /> {busy ? "Preparing..." : "Annual report (PDF)"}
      </Button>
      <SendToClientButton kind="csat_annual" year={Number(year)} clientSlug={clientSlug} />
    </div>
  );
};
